import instance from '../axios';

export interface RegisterUserData {
    name: string
    emailAddress: string
    profilePictureUrl?: string
    isSubscribedToEmailNotifications?: boolean
    region?: string
}

export const usersApi = {
    register: (token: string, data: RegisterUserData) =>
        instance.post('/users/register', data, {
            headers: { Authorization: `Bearer ${token}` }
        }),

    getCurrentUser: (token: string) =>
        instance.get('/users/me', {
            headers: { Authorization: `Bearer ${token}` }
        }),

    updateDisplayName: (token: string, name: string) =>
        instance.put('/users/me', { name }, {
            headers: { Authorization: `Bearer ${token}` }
        }),

    // Partial update: only the provided fields change.
    updateProfile: (token: string, data: { name?: string; username?: string; bio?: string }) =>
        instance.put('/users/me', data, {
            headers: { Authorization: `Bearer ${token}` }
        }),

    usernameAvailable: (token: string, username: string) =>
        instance.get<{ available: boolean }>('/users/username-available', {
            params: { username },
            headers: { Authorization: `Bearer ${token}` }
        })
};